import Hero from './Hero';
import AtelierInfo  from './AtelierInfo';
import ImageCrousel from './ImageCarousel';
import Bio from './Bio';
import Critics from './Critics';
import Footer from '../core/Footer';

function Homepage() {
    return (
      <div className="Homepage overflow-x-hidden">
        <Hero />
        <AtelierInfo />
        <ImageCrousel />
        <Critics />
        <Bio />
        <Footer />
      </div>
    );
  }
  
  export default Homepage;